import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { hdDailyPlayerDetails } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { productList } from "@/api/management/productMapping";
import { gmTool, serchSelect, tabulation } from "@/mixins/index";
export default {
  name: "playerDailyDetailSnapshot",
  mixins: [gmTool, serchSelect, tabulation],
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      dayList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      paramsData: {
        special_product_id: [],
        role_id: "",
        open_server_day: "",
        page: 1,
        server_id: [],
        server_ids: [],
        is_prod: ""
      },
      date: [],
      total: 0,
      serverList: []
    };
  },
  created: function created() {
    this.paramsData.is_prod = "";
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    serverListChange: function serverListChange(e) {
      console.log("eeee", e);
    },
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.paramsData.page = e;
                _this.reqLoading = true;
                _this.paramsData.server_id = []; //服务器数据处理

                if (_this.paramsData.server_ids && _this.paramsData.server_ids.length != 0) {
                  _this.paramsData.servers = _this.paramsData.server_ids.map(function (item) {
                    _this.paramsData.server_id.push(item.split("+")[0]);

                    return {
                      openTimeTimestamp: item.split("+")[1],
                      id: item.split("+")[0]
                    };
                  });
                } else {
                  _this.paramsData.servers = [];
                  _this.paramsData.server_id = [];
                  _this.paramsData.open_server_day = [];
                }

                params = JSON.parse(JSON.stringify(_this.paramsData));
                params.open_server_day = params.open_server_day && params.open_server_day.join(",");

                if (params.server_id.length) {
                  params.server_id = params.server_id.join(",");
                }

                if (_this.searchData.special_product_id.length) {
                  params.special_product_id = _this.searchData.special_product_id.join(",");
                }

                delete params.server_ids;
                hdDailyPlayerDetails(_objectSpread(_objectSpread({}, params), {}, {
                  game_id: _this.rawData.game_id
                })).then(function (res) {
                  if (res.status == 200) {
                    _this.currentPage = 1;
                    _this.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
                    _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage); // this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getServer: function getServer() {
      var _this2 = this;

      // this.paramsData.serverID = ''
      this.paramsData.server_ids = [];
      this.paramsData.open_server_day = [];
      serverList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: ''
      })).then(function (res) {
        if (res.status == 200) {
          _this2.serverList = res.data;
        }
      });
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var list, columns;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                list = _this3.tableCopyTableList;
                columns = [{
                  label: '服务器',
                  prop: 'server_id'
                }, {
                  label: '开服第几天',
                  prop: 'server_day'
                }, {
                  label: '角色ID',
                  prop: 'role_id'
                }, {
                  label: '角色名字',
                  prop: 'role_name'
                }, {
                  label: '角色当日游玩时长',
                  prop: 'duration'
                }, {
                  label: '角色等级',
                  prop: 'level'
                }, {
                  label: '角色战力',
                  prop: 'fighting'
                }, {
                  label: '主线关卡',
                  prop: 'main_line_task'
                }, {
                  label: '爬塔层数',
                  prop: 'pata'
                }, {
                  label: '累计充值',
                  prop: 'total_amount'
                }];

                _this3.$export.excel({
                  columns: columns,
                  data: list,
                  title: _this3.$route.meta.title
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};